import React, {Component, PropTypes} from 'react';
import {
  Button,
  Modal,
  FormGroup,
  Form,
  Col,
  FormControl,
  ControlLabel,
} from '@sketchpixy/rubix';
import styled from 'styled-components';
import {ClipLoader} from 'react-spinners';
import {css} from 'react-emotion';

import ServiceType from '../../../constants/ServiceType';

import {
   getContentMeta,
   updateContentMeta,
   getContentClients
} from '../../../api/api';

const override = css`
margin-top: -550px;
`;

class ContentMetaEditModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      contentClients: [],
      contentMeta : {
         contentMetaId: null,
         contentClientId: null,
         contentId: '',
         additionalJson: '',
         rapaelClientId: ''
      },
      file:'',
      loading: false
    };
  }

  onContentIdChange = (event) => {
        var contentMeta= {...this.state.contentMeta}
        contentMeta.contentId = event.target.value;
        this.setState({
          contentMeta: contentMeta,
        });
      }

  additionalJsonChange = (event) => {
       var contentMeta= {...this.state.contentMeta}
       contentMeta.additionalJson = event.target.value;
       this.setState({
           contentMeta: contentMeta,
       });
  }

  contentClientChange = (event) => {
        var contentMeta= {...this.state.contentMeta}
        contentMeta.contentClientId = event.target.value;
        this.setState({
            contentMeta: contentMeta,
      });
  }

  saveContentMeta = (event) => {
     let self = this;

     let jsonStr = self.state.contentMeta.additionalJson;
     try {
         JSON.parse(jsonStr);
     } catch (e) {
        vex.dialog.alert('JSON is not valid!');
        return;
     }

     
     self.setState({
         loading: true,
     });
     updateContentMeta(self.state.contentMeta, (err, res) => {
         self.setState({
             loading: false,
         });
         if (err) {
            vex.dialog.alert('Failed to update Content!');
          } else {
            vex.dialog.alert('Content Updated!');
            self.setState({
                contentMeta: res.meta,
            });
          }
     });
  }

  onShowModal = (evt) => {
    if(this.props.contentMetaId)
    {
        getContentMeta(this.props.contentMetaId, (err, res) => {
          this.setState({
              contentMeta: res.meta,
          });
        });
    }else{
        let contentMeta = {
             contentMetaId: null,
             contentClientId: null,
             contentId: '',
             additionalJson: '',
             rapaelClientId: ''
        };

        if(this.props.rapaelClientId)
        {
            contentMeta.rapaelClientId =  this.props.rapaelClientId;
        }

        this.setState({
            contentMeta: contentMeta,
        });
    }
    
    getContentClients(this.props.rapaelClientId, (err, result) => {
        this.setState({
           contentClients: result.result,
        });
    });
  }

  render() {
    return (
        <Modal
            show={this.props.showModal}
            onHide={this.props.closeModal}
            onEntered = {this.onShowModal}
            backdrop="static"
            style={{width:'100%'}}
        >
          <Modal.Header closeButton>
            <Modal.Title>Edit Content</Modal.Title>
          </Modal.Header>
          <Modal.Body>
             <Form>
                 <FormGroup>
                     <ControlLabel>Content Id</ControlLabel>
                     <FormControl type='text' placeholder='Content Id'  value={this.state.contentMeta.contentId} onChange={this.onContentIdChange}/>
                 </FormGroup>
                  <FormControl
                     onChange={this.contentClientChange}
                     componentClass="select"
                     value={this.state.contentMeta.contentClientId}
                 >
                   <option value=''>Select</option>
                   {
                     this.state.contentClients.map(contentClient => (
                         <option key={contentClient.contentClientId} value={contentClient.contentClientId}>
                           {contentClient.packageName}/{contentClient.versionName}/{contentClient.versionCode}
                         </option>
                     ))
                   }
                 </FormControl>
                 <FormGroup>
                      <ControlLabel>Additional JSON</ControlLabel>
                      <FormControl componentClass='textarea' rows='10' placeholder='Additional JSON...' value={this.state.contentMeta.additionalJson} onChange={this.additionalJsonChange}/>
                 </FormGroup>
             </Form>
             <ClipLoader
             className={override}
             sizeUnit={'px'}
             size={500}
             color={'#123abc'}
             loading={this.state.loading}>
             </ClipLoader>
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle='primary' onClick={this.saveContentMeta}>Save</Button>
            <Button onClick={this.props.closeModal}>Cancel</Button>
          </Modal.Footer>
        </Modal>
    );
  }
}

ContentMetaEditModal.propTypes = {
  contentMetaId: PropTypes.number,
  rapaelClientId: PropTypes.number,
  showModal: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired
};

export default ContentMetaEditModal;



// WEBPACK FOOTER //
// ./src/routes/ReleaseMgnt/components/ContentMetaEditModal.js